import { render, staticRenderFns } from "./LmsHome.vue?vue&type=template&id=9385a776&scoped=true"
import script from "./LmsHome.vue?vue&type=script&lang=js"
export * from "./LmsHome.vue?vue&type=script&lang=js"
import style0 from "./LmsHome.vue?vue&type=style&index=0&id=9385a776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9385a776",
  null
  
)

export default component.exports